import React from "react";
import styled from "styled-components";
import { defaultTheme } from "../../shared/constants";

interface DividerProps {
  text?: string;
}

export const Divider: React.FC<DividerProps> = ({ text }) => {
  return (
    <DividerContainer>
      <DividerLine />
      {text && <DividerText>{text.toLocaleLowerCase()}</DividerText>}
    </DividerContainer>
  );
};

const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 8px 0;
  width: 100%;
`;

const DividerLine = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  border-top: 1px solid ${defaultTheme.COLORS.GRAY_MEDIUM};
  transform: translateY(-50%);
`;

const DividerText = styled.span`
  position: relative;
  background: white;
  padding: 0 10px;
  font-size: ${defaultTheme.FONT.SIZE.EXTRA_SMALL};
  color: ${defaultTheme.COLORS.DARK_GREY};
`;
